import { z } from 'zod';

/**
 * Validation schema for a single role
 */
export const roleSchema = z.object({
  roleId: z.number(),
  name: z
    .string()
    .trim()
    .min(1, 'authenticated.settings:pages.roles.errors.nameRequired')
    .max(100, 'authenticated.settings:pages.roles.errors.nameTooLong'),
  memberCount: z.number(),
});

/**
 * Validation schema for roles form
 * Includes duplicate name validation
 */
export const rolesFormSchema = z.object({
  roles: z.array(roleSchema).superRefine((roles, ctx) => {
    // Check for duplicate names (case-insensitive)
    const names = new Map<string, number>();

    roles.forEach((role, index) => {
      const normalizedName = role.name.toLowerCase().trim();

      if (normalizedName) {
        const firstIndex = names.get(normalizedName);

        if (firstIndex !== undefined && firstIndex !== index) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'authenticated.settings:pages.roles.errors.duplicateName',
            path: [index, 'name'],
          });
        } else {
          names.set(normalizedName, index);
        }
      }
    });
  }),
});

/**
 * Validation schema for delete role modal
 */
export const deleteRoleSchema = z.object({
  replacementRoleId: z.number().optional(),
});

export type RolesFormData = z.infer<typeof rolesFormSchema>;
export type DeleteRoleFormData = z.infer<typeof deleteRoleSchema>;
